module.exports = __webpack_public_path__ + "img/9_42.48f45edd.png";